module.exports = __webpack_public_path__ + "static/media/bg-get-started.94006f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GetStarted/bg-get-started.png
// module id = 1660
// module chunks = 0